import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PinPendingChecklist } from "models";

export const useReorderPinPendingChecklistMutation = () =>
  useTypedMutation<PinPendingChecklist[], void>({
    mutationFn: async pin_pending_checklists => (await ApiInstance.post("/pin_pending_checklists/reorder", { pin_pending_checklists }, ENV.dealerBaseURL)).data,
    onSuccess: reorderedChecklists => {
      const pinPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.pinPendingChecklists);
      if (!pinPendingChecklists?.length || !reorderedChecklists.length) return;

      const otherChecklists = pinPendingChecklists.filter(p => p.pin_type !== reorderedChecklists[0].pin_type);
      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.pinPendingChecklists, [...otherChecklists, ...reorderedChecklists]);
    }
  });
